// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hexa","textarea":"styles_textarea__i1xzi"};